export enum StorageLocationService {
  SameDayStorage = 'SameDayStorage',
  MultiDayStorage = 'MultiDayStorage',
  Swapping = 'Swapping',
  GuestLuggageStorage = 'GuestLuggageStorage',
}
